/**
 * List of functions that extends Web Components
 */

import { generateIdAttribute } from './_domFunctions';

/**
 * Collect all elements with 'ref' attribute contains in the component DOM
 * and add them in a "refs" registry.
 * Usage: In constructor: useRefs.call(this)
 */
export function collectRefs() {
    const refs = [...this.querySelectorAll('[ref]')];
    if (refs.length > 0) {
        this.refs = {};

        refs.forEach((el) => {
            // Scope check
            if (el.parentNode.closest('[is]') !== this) {
                return;
            }
            this.refs[el.getAttribute('ref')] = el;
            el.removeAttribute('ref');
        });
    }
}

/**
 * Ensure that there is an ID attribut.
 * If not, try to generate a unique ID depending on the current webcomponent used.
 * Usage: In constructor: ensureIdAttribute.call(this)
 */
export function ensureIdAttribute() {
    if (this.id) {
        return;
    }
    const componentName = this.constructor.name.toLowerCase();
    this.id = generateIdAttribute(componentName);
}
